import logger from '../logger';
let lastCpuPressure: string | null = null;

// Pressure states:
//
// ⚪ "nominal": The conditions of the target device are at an acceptable level with no noticeable adverse effects on the user.
//
// 🟢 "fair": Target device pressure, temperature and/or energy usage are slightly elevated, potentially resulting in reduced battery-life,
// as well as fans (or systems with fans) becoming active and audible. Apart from that the target device is running flawlessly and can take on additional work.
//
// 🟡 "serious": Target device pressure, temperature and/or energy usage is consistently highly elevated. The system may be throttling as a countermeasure to reduce thermals.
//
// 🔴 "critical": The temperature of the target device or system is significantly elevated and it requires cooling down to avoid any potential issues.
export async function setupPerformanceLogging() {
  // Setup CPU observer
  if ('PressureObserver' in window) {
    try {
      const observer = new (window as any).PressureObserver((records: any[]) => {
        const last = records.at(-1);
        lastCpuPressure = last.state; // store latest CPU state
      });
      // Observe CPU with high-frequency sampling internally
      observer.observe('cpu', { sampleInterval: 1000 });
    } catch (err) {
      console.warn('[PERF] Failed to start PressureObserver:', err);
    }
  } else {
    console.log('[PERF] PressureObserver not supported');
  }

  // Log CPU + memory every minute
  setInterval(() => {
    // Memory
    let memoryUsage = 'N/A';
    const perfWithMemory = performance as Performance & {
      memory?: { usedJSHeapSize: number; jsHeapSizeLimit: number };
    };

    if (perfWithMemory.memory) {
      // Reflects JS heap only — not total memory used by the tab (graphics, DOM, etc.).
      const { usedJSHeapSize, jsHeapSizeLimit } = perfWithMemory.memory;
      memoryUsage = `${(usedJSHeapSize / 1024 / 1024).toFixed(2)} MB / ${(jsHeapSizeLimit / 1024 / 1024).toFixed(2)} MB`;
    }

    // CPU
    const cpuState = lastCpuPressure ?? 'N/A';

    const message = `[PERF] CPU: ${cpuState}, Memory: ${memoryUsage}`;
    console.log(message);
    logger.log(message);
  }, 60_000);
}
